const loadQuickView = async (handle, e) => {
  e.preventDefault()
  const res = await fetch(`${window.Shopify.shop}/products/${handle}?view=new-pdp&sections=product-qv-new-pdp`)
  const json = await res.json()
  qv_modal.showModal()
  qv_content.innerHTML = json["product-qv-new-pdp"]

  // carousels logic
  const npdp_swiper_thumbs = new Swiper(".npdp-thumbs-swiper", {
    slidesPerView: 4,
    direction: "vertical"
  });

  const npdp_swiper_gallery = new Swiper(".npdp-swiper", {
    loop: true,
    navigation: {
      nextEl: ".npdp-gallery .gallery-next",
      prevEl: ".npdp-gallery .gallery-prev",
    },
    pagination: {
      el: ".npdp-gallery .swiper-pagination",
      renderBullet: function (index, className) {
        return '<div class="' + className + '"></div>';
      }
    },
    thumbs: {
      swiper: npdp_swiper_thumbs,
    },
    /* breakpoints: {
      769: {
      }
    } */
  });

  const addZoomToGallery = _ => {
    npdp_swiper_gallery.slides.forEach(slide => {
      if (!slide.classList.contains('npdp-video') || !slide.classList.contains('npdp-iframe')) {
        slide.addEventListener("click", e => {
          let galleryMedia = []
          npdp_swiper_gallery.slides.forEach(media => {
            galleryMedia = [...galleryMedia, media.querySelector("[data-file], video, iframe")]
          })
          $s.photoSwipe(galleryMedia, slide.querySelector("[data-file]"));
        })
      }
    })
  }
  const updateCarouselImages = _ => {
    const allImages = document.querySelector(".npdp-gallery-data")
    const checkedOption = document.querySelector("form#new_pdp_form input[name='color']")
    const checkedLetter = document.querySelector("form#new_pdp_form .option[data-name='Initial'] select")
    if (!checkedOption) {
      const galleryImages = allImages.querySelectorAll(`.gallery-data > .swiper-slide, .gallery-data > .swiper-slide.npdp-video, .gallery-data > .swiper-slide.npdp-iframe`)
      const thumsImages = allImages.querySelectorAll(`.thums-data > .swiper-slide, .thums-data > .swiper-slide.npdp-video, .thums-data > .swiper-slide.npdp-iframe`)
      galleryImages.forEach(slide => {
        const newSlide = slide.cloneNode(true)
        npdp_swiper_gallery.appendSlide(newSlide)
      })
      thumsImages.forEach(slide => {
        const newSlide = slide.cloneNode(true)
        npdp_swiper_thumbs.appendSlide(newSlide)
      })
      npdp_swiper_gallery.update()
      /* addZoomToGallery() */
      return
    }
    // select variant images
    const galleryImages = allImages.querySelectorAll(`.gallery-data > .swiper-slide[data-alt*='${checkedOption?.value.replace(",", "+")}']${checkedOption.value.includes(",") ? "" : ":not([data-alt*='+'])"}, .gallery-data > .swiper-slide.npdp-video, .gallery-data > .swiper-slide.npdp-iframe`)
    const thumsImages = allImages.querySelectorAll(`.thums-data > .swiper-slide[data-alt*='${checkedOption?.value.replace(",", "+")}']${checkedOption.value.includes(",") ? "" : ":not([data-alt*='+'])"}, .thums-data > .swiper-slide.npdp-video, .thums-data > .swiper-slide.npdp-iframe`)

    // reset carousel images
    npdp_swiper_thumbs.removeAllSlides()
    npdp_swiper_gallery.removeAllSlides()

    // put variant images
    galleryImages.forEach(slide => {
      const newSlide = slide.cloneNode(true)
      if (checkedLetter) {
        if (slide.dataset.alt.includes(`,${checkedLetter.value}`)) {
          npdp_swiper_gallery.appendSlide(newSlide)
        } else if (!slide.dataset.alt.includes(",")) {
          npdp_swiper_gallery.appendSlide(newSlide)
        }
      } else {
        npdp_swiper_gallery.appendSlide(newSlide)
      }
    })
    thumsImages.forEach(slide => {
      const newSlide = slide.cloneNode(true)
      if (checkedLetter) {
        if (slide.dataset.alt.includes(`,${checkedLetter.value}`)) {
          npdp_swiper_thumbs.appendSlide(newSlide)
        } else if (!slide.dataset.alt.includes(",")) {
          npdp_swiper_thumbs.appendSlide(newSlide)
        }
      } else {
        npdp_swiper_thumbs.appendSlide(newSlide)
      }
    })
    npdp_swiper_gallery.update()
    /* addZoomToGallery() */
  }
  // set firtime carousel images
  updateCarouselImages()

  // utils functions

  function updateURLParam(key, value) {
    var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''), urlQueryString = document.location.search, newParam = key + '=' + value, params = '?' + newParam;
    if (urlQueryString) {
      let keyRegex = new RegExp('([\?&])' + key + '[^&]*');
      if (urlQueryString.match(keyRegex) !== null)
        params = urlQueryString.replace(keyRegex, "$1" + newParam);
      else
        params = urlQueryString + '&' + newParam;
    }
    window.history.replaceState({}, "", baseUrl + params);
  }
  /* const firstVariant = variant_id.selectedOptions[0]
  let currentVariant = {
    id: variant_id.value,
    title: firstVariant.dataset.title,
    src: firstVariant.dataset.src,
    price: +firstVariant.dataset.price / 100
  } */
  const updateVariant = (updateGallery, isColor, value) => {
    if (updateGallery) {
      updateCarouselImages()
    }
    if (isColor) {
      document.querySelectorAll("form#new_pdp_form .option:not(.opt-extra) select").forEach((select, index) => {
        const optionsSelect = select.querySelectorAll("option")
        let realOptions = []
        variant_id.querySelectorAll(`option[data-option1='${value}']`).forEach(option => {
          realOptions = [...realOptions, option.dataset[`option${index + 2}`]]
        })
        optionsSelect.forEach(option => {
          if (realOptions.some(realOpt => realOpt == option.value)) {
            option.removeAttribute("hidden")
          } else {
            option.setAttribute("hidden", true)
          }
        })
      })
    }
    let options = []
    document.querySelectorAll('form#new_pdp_form .option:not(.opt-extra)').forEach(option => {
      const optValue = option.querySelector("input[name='color']") ? option.querySelector("input[name='color']")?.value : option.querySelector("select")?.value
      options = [...options, [option.dataset.name, optValue]]
    })
    const query = options.reduce((acc, option, index) => acc += `[data-option${index + 1}="${option[1]}"]`, "")
    const selectedOption = variant_id.querySelector(`option${query}`)
    const notifyBtn = document.querySelector(".notify-btn")
    const atc_btn = document.querySelector('form#new_pdp_form input[type="submit"]')
    const input_lt = document.querySelector('form#new_pdp_form input[name="properties[Lead Time]"]')
    input_lt.value = selectedOption.dataset.leadTime
    if (selectedOption.dataset.leadTime != "" && selectedOption.dataset.leadTime !== 'Ready to Ship!' && selectedOption.dataset.leadTime !== 'Only 1 Left') {
      input_lt.removeAttribute("disabled")
    } else {
      input_lt.setAttribute("disabled", "true")
    }
    if (selectedOption.dataset.leadTime.includes("Notify")) {
      lt_con.style.display = "none"
      notifyBtn.classList.remove("hide")
      atc_btn.classList.add("hide")
    } else if (selectedOption.dataset.leadTime == "") {
      lt_con.style.display = "none"
      notifyBtn.classList.add("hide")
      atc_btn.classList.remove("hide")
    } else {
      lt_con.style.display = "flex"
      notifyBtn.classList.add("hide")
      atc_btn.classList.remove("hide")
      ship_time.textContent = selectedOption.dataset.leadTime
    }
    updateURLParam('variant', selectedOption.value)
    variant_id.value = selectedOption.value
    /* currentVariant = {
      id: variant_id.value,
      title: selectedOption.dataset.title,
      src: selectedOption.dataset.src,
      price: +selectedOption.dataset.price / 100
    } */
    /* if (typeof _swat !== 'undefined') _swat.fetchWrtEventTypeET(fetchCallbackFn, 4); */
  }
  // set correct options  first time
  updateVariant(false, true, document.querySelector("form#new_pdp_form input[name='color']")?.value)
  document.querySelectorAll("form#new_pdp_form .option:not(.opt-extra) select, form#new_pdp_form .option:not(.opt-extra) input[name='color']").forEach(input => {
    input.addEventListener("change", e => {
      updateVariant(e.target.getAttribute("name") == "color" || e.target.dataset.name == "Initial", e.target.getAttribute("name") == "color", e.target.value)
    })
  })

  document.querySelector("form#new_pdp_form .input-engraving #engraving_box")?.addEventListener("change", e => {
    document.querySelector(".npdp-engraving .e-con").classList.toggle("disabled")
    document.querySelector(".npdp-engraving .e-final-sale").classList.toggle("hide")
    document.querySelectorAll(".npdp-engraving .e-final-sale input, .npdp-engraving input#engraving_text, .npdp-engraving .engraving-inputs input").forEach(input => {
      if (!e.target.checked) {
        input.setAttribute("disabled", "true")
      } else {
        input.removeAttribute("disabled")
      }
    })
    const atc_btn = document.querySelector('form#new_pdp_form input[type="submit"]')
    if (e.target.checked && !document.querySelector(".npdp-engraving .e-final-sale input").checked) {
      atc_btn.classList.add("disabled")
    } else {
      atc_btn.classList.remove("disabled")
    }
  })

  document.querySelector('form#new_pdp_form .npdp-engraving input[type="text"][name="properties[Engraving]"]')?.addEventListener("change", e => {
    document.querySelector('form#new_pdp_form .npdp-engraving .engraving-inputs #engraving_2').value = e.target.value
  })

  document.querySelector("form#new_pdp_form input#final_sale")?.addEventListener("change", _ => {
    const atc_btn = document.querySelector('form#new_pdp_form input[type="submit"]')
    atc_btn.classList.toggle("disabled")
  })

  // close custom select on outside click

  const customSelectJewerly = document.querySelector("form#new_pdp_form .npdp-custom-select:not(.npdp-custom-select-color)")
  if (customSelectJewerly) {
    window.addEventListener("click", e => {
      if (!e.composedPath().includes(customSelectJewerly) && customSelectJewerly.classList.contains("open")) {
        customSelectJewerly.classList.remove('open')
      }
    });
  }

  const customSelectEngraving = document.querySelector("form#new_pdp_form .npdp-custom-select-color")
  if (customSelectEngraving) {
    window.addEventListener("click", e => {
      if (!e.composedPath().includes(customSelectEngraving) && customSelectEngraving.classList.contains("open")) {
        customSelectEngraving.classList.remove('open')
      }
    });
  }

  // form logic
  const atc_form = document.querySelector("#new_pdp_form")
  atc_form.addEventListener("submit", e => {
    e.preventDefault()
    const jewerlyServiceInputs = document.querySelectorAll('form#new_pdp_form .jewerly-inputs input[name*="properties[_bundle_id]"]')
    const engravingInputs = document.querySelectorAll('form#new_pdp_form .engraving-inputs input[name*="properties[_bundle_id]"]')
    if (jewerlyServiceInputs.length > 0 || engravingInputs.length > 0) {
      const bundleId = new Date().getTime()
      jewerlyServiceInputs.forEach(input => {
        input.value = bundleId
      })
    }
    if (engravingInputs.length > 0) {
      const bundleId = new Date().getTime()
      engravingInputs.forEach(input => {
        input.value = bundleId
      })
    }
    const formData = new FormData(atc_form);
    qv_modal.close()
    $s.showLoadingOverlay();

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(response => {
        $s.hideLoadingOverlay()
        if (response.ok) {
          return response.json().then(data => {
            if ($s.isAddToCartPopupEnabled()) {
              $s.showAddToCartPopup(data)
            } else {
              window.SideCart.updateSideCart(true)
            }
            return data
          });
        }
        return response.json();
      })
      .catch((error) => {
        $s.hideLoadingOverlay()
        console.error('Error:', error);
      });
  })
}

const changeColor = e => {
  const colorInput = document.querySelector("form#new_pdp_form input[name='color']")
  document.querySelector("form#new_pdp_form .npdp-custom-select-color .drop-options .drop-option.selected").classList.remove("selected")
  document.querySelector("form#new_pdp_form .npdp-custom-select-color .selected-opt > .drop-option-default").innerHTML = e.currentTarget.innerHTML
  e.currentTarget.classList.add("selected")
  e.currentTarget.closest(".npdp-custom-select").classList.remove("open")
  colorInput.value = e.currentTarget.dataset.value
  colorInput.dispatchEvent(new Event("change"))
}
const changeJewerlyService = e => {
  document.querySelector("form#new_pdp_form .npdp-custom-select:not(.npdp-custom-select-color) .drop-options .drop-option.selected").classList.remove("selected")
  const inputs = document.querySelectorAll("form#new_pdp_form .jewerly-inputs input")
  if (e.currentTarget.dataset.id == "none") {
    document.querySelector("form#new_pdp_form .npdp-custom-select:not(.npdp-custom-select-color) .selected-opt > p").textContent = e.currentTarget.dataset.name
    inputs.forEach(input => {
      input.setAttribute("disabled", "true")
    })
  } else {
    document.querySelector("form#new_pdp_form .npdp-custom-select:not(.npdp-custom-select-color) .selected-opt > p").innerHTML = `<div class="drop-color" style="--bg: ${e.currentTarget.dataset.color}"></div><span>${e.currentTarget.dataset.name}</span>`
    document.querySelector('form#new_pdp_form .jewerly-inputs input[name="items[1][id]"]').value = e.currentTarget.dataset.id
    inputs.forEach(input => {
      input.removeAttribute("disabled")
    })
  }
  e.currentTarget.classList.add("selected")
  e.currentTarget.closest(".npdp-custom-select:not(.npdp-custom-select-color)").classList.remove("open")
}
/* loadQuickView("lauren-joy-medium-disc-necklace") */
/* loadQuickView("reese-brooklyn-scalloped-initial-charm") */
/* loadQuickView("drd-double-initial-ring") */
/* loadQuickView("poppy-rae-u-hoop") */